import { ResourceTimelineMessageListItemDto, SortDirectionDto } from '@/api/generated';
import { CustomTableStateModel } from '@/components/table/model/CustomTableState.model.ts';
import { ResourceTimelineMessagesFormModel } from '@/components/timelineMessages/model/ResourceTimelineMessagesForm.model.ts';

export type ResourceTimelineMessagesTableState = CustomTableStateModel<
  string,
  ResourceTimelineMessagesFormModel,
  ResourceTimelineMessageListItemDto
>;

export const initialResourceTimelineMessagesTableState: ResourceTimelineMessagesTableState = {
  data: {
    items: [],
    totalPages: 0,
    totalResults: 0,
  },
  page: 0,
  pageSize: 10,
  params: {},
  sortBy: '',
  sortOrder: SortDirectionDto.Asc,
};
